import { useTheme } from "../../../../hooks/useTheme";
import PopupModalContainer, {
  PopupModalContainerWidth,
} from "../../../Containers/PopupModalContainer";
import CustomTextField from "../../../CustomTextField";
import { Colors } from "../../../../utils/colors";
import RectangleButton from "../../../Buttons/RectangleButton";
import { useCallback, useState } from "react";
import { DMAutomation, NotificationType } from "@markit/common.types";
import {
  Batch,
  getUserCampaignRef,
  getUserDmAutomationRef,
} from "../../../../utils/FirebaseUtils";
import { useDispatch } from "react-redux";
import { showNotificationBanner } from "../../../../utils/notificationUtils";

type DMAutomationRenameModalProps = {
  dmAutomation: DMAutomation;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
};

const DMAutomationRenameModal = (props: DMAutomationRenameModalProps) => {
  const { dmAutomation, showModal, setShowModal } = props;
  const dispatch = useDispatch();
  const { theme } = useTheme();
  const [newDmAutomationName, setNewDmAutomationName] = useState(
    dmAutomation.title
  );
  const [dmAutomationNameError, setDmAutomationNameError] = useState("");

  const renameDmAutomationOnPress = useCallback(async () => {
    if (!newDmAutomationName.trim()) {
      setDmAutomationNameError("The DM Automation name cannot be empty.");
      return;
    }
    const dmAutomationRef = getUserDmAutomationRef(
      dmAutomation.createdBy,
      dmAutomation.id
    );

    const batch = new Batch();
    batch.update(dmAutomationRef, { title: newDmAutomationName });
    if (dmAutomation.campaignId) {
      const campaignRef = getUserCampaignRef(
        dmAutomation.createdBy,
        dmAutomation.campaignId
      );
      batch.update(campaignRef, { title: newDmAutomationName });
    }
    await batch.commit();

    setShowModal(false);
    setNewDmAutomationName("");
    showNotificationBanner(
      dispatch,
      "Name Updated",
      NotificationType.AFFIRMATIVE
    );
  }, [dmAutomation, newDmAutomationName, setShowModal, dispatch]);

  return (
    <PopupModalContainer
      valueComp={
        <div className="ColumnNormal" style={{ gap: 20 }}>
          <div className="ColumnNormal" style={{ gap: 7 }}>
            <span className="bodyMedium">Edit Automation Name</span>
            <div className="ColumnNormal" style={{ gap: 4 }}>
              <CustomTextField
                value={newDmAutomationName}
                placeholder="DM Automation Name"
                inputMode="text"
                borderRadius={12}
                onChange={(name: any) => {
                  setDmAutomationNameError("");
                  setNewDmAutomationName(name.target.value);
                }}
                maxLength={60}
                error={dmAutomationNameError !== ""}
              />
              {dmAutomationNameError ? (
                <span
                  className="smallBodySubtext"
                  style={{ color: Colors.RED3 }}
                >
                  {dmAutomationNameError}
                </span>
              ) : null}
            </div>
            <span className="smallBodySubtext">
              {newDmAutomationName.length}/60
            </span>
          </div>
          <RectangleButton
            buttonLabel="Save"
            onPress={renameDmAutomationOnPress}
            altTextColor={Colors.WHITE}
            altColor={Colors.BLACK}
            altPaddingVert={14}
            disabled={dmAutomation.title === newDmAutomationName}
          />
        </div>
      }
      noExit
      noDivider
      closeOnOutsidePress
      closeModal={() => setShowModal(false)}
      hideModal={!showModal}
      theme={theme}
      modalContentWidth={PopupModalContainerWidth.SMALL}
    />
  );
};

export default DMAutomationRenameModal;
